import { useEffect, useState } from "react";
import { Route, Routes, Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "./navbar";
import OffCanvas from "./offCanvas";
import Dashboard from "./dashboard";
import Employee from "../employee/employee";
import DetailsofEmp from "../employee/details";
import AddEmployee from "../employee/addEmployee";
import BackdropOffcanvas from "./BackdropOffcanvas";
import SelfLeaveTable from "../leaves/selfLeav";
import LeaveDetail from "../leaves/leaveDetail";
import LeaveShow from "../leaves/leaveShow";
import RequestView from "../leaves/leaveRequest";
import TodayLeaves from "../leaves/todayLeaves";
import LeaveReport from "../leaves/LeaveReport";
import { ProfilePage } from "../employee/profilepage";
import AddUser from "../admin/addUser";
import CreateUser from "../admin/createUser";
import AllAttendence from "../attendence/allAttendence";
import MyAttendence from "../attendence/myAttendence";
import EarlyLate from "../attendence/EarlyLate";
import "./container.css";
import TabPanel from "../admin/functionalities";
import Branchs from "../admin/branchs";
import Departments from "../admin/Departments";
import JobPosition from "../admin/jobPosition";
import BranchDetails from "../admin/branchDetails";
import DepartmentDetails from "../admin/depDetails";
import PositionDetails from "../admin/positionDetails";
import EditEmployee from "../employee/editEmployee";
import Shifts from "../admin/shifts";
import ShiftDetails from "../admin/shiftDetails";
import SalarySlip from "../employee/salarySlip";
import SingleSalarySlip from "../employee/singleSlip";
import Allowance from "../admin/allowance";
import CourseList from "../courses/courseList";
import CourseDetails from "../courses/courseDetails";
import Subjects from "../courses/subCourses";
import SubjectDetails from "../courses/subjectDetails";
import SingleTask from "../courses/singleTask";
import SingleDayFullPunch from "../attendence/dayFullPunch";
import SingleUserReport from "../leaves/singleUserReport";
import Subshift from "../admin/subShift";
import SubShiftAdd from "../admin/subShiftAdd";
import WorkingHours from "../attendence/workingHours";
import UserTime from "../attendence/userTime";
import Listing from "../Registration/Listing";
import AddStudent from "../Registration/addStudent";
import StudentDetails from "../Registration/studentDet";
import EditStudent from "../Registration/editStudent";
import Download from "../Registration/download";
import Report from "../attendence/report";
import StdRegular from "../attendence/std_regular";
import RequestList from "../attendence/requestList";
import LeaveBalance from "../leaves/leaveBalance";
import ConvertRequests from "../attendence/convertReq";
import LeaveConvert from "../attendence/leaveConvert";
import Batches from "../Registration/batches";
import BatchDetails from "../Registration/batchDetails";
import SalarySlipList from "../employee/salarySlipList";
import FeeReport from "../Registration/feeReport";
import StudentDayPunch from "../Registration/studentdayPunch";
import StudentAttendanceReport from "../Registration/st_att_report";
import RoleDetails from "../admin/roleDetails";
import ProcessSalary from "../employee/ProcessSalary";
import PolicyPage from "../admin/PolicyPage";
import Hierarchy from "../admin/hierarchy";
import WorkingHouresReport from "../attendence/WorkingHouresReport";
import OrganizationTree from "../admin/hirarchyImg";

// Not Found Component
const NotFound = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
      <h3>Page Not Found</h3>
    </div>
  );
};

// Protected Route Component
const ProtectedRoute = ({ element, permissionIds, userIdParamKey }) => {
  const permissions = useSelector((state) => state.emp.permissions);
  const params = useParams();
  const userId = localStorage.getItem("userId");

  // Check if any of the required permission IDs are present
  const hasPermission = Array.isArray(permissionIds)
    ? permissionIds.some((id) => permissions.includes(id))
    : permissions.includes(permissionIds);

  // Check if the URL parameter matches the userId (if userIdParamKey is provided)
  const isUserIdMatch = userIdParamKey && params[userIdParamKey] && params[userIdParamKey] === userId;

  // Allow access if either the permission is present or the userId matches (if applicable)
  const isAuthorized = hasPermission || (userIdParamKey && isUserIdMatch);

  return isAuthorized ? element : <Navigate to="/not-found" replace />;
};

export default function FixedNavAndCanvas() {
  const [mainwidth, setMainWidth] = useState(false);
  const [canvasWidth, setCanvasWidth] = useState("74px");
  const [opaacity, setOpacity] = useState("0%");
  const [hide, setHide] = useState("none");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isBelow1000px, setIsBelow1000px] = useState(window.innerWidth < 1000);

  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);

  const { emp_list, emp_count } = useSelector((state) => state.emp);
  console.log("emplyee count is :", emp_count);
  console.log("emplyee list is :", emp_list);

  useEffect(() => {
    const fetchData = () => {
      console.log('env is ', process.env.REACT_APP_SAMPLE);
      setTimeout(() => {
        setProduct(require("../jsonFiles/sidebar.json"));
        setLoading(false);
      }, 1000);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = document.documentElement.clientWidth;
      setWindowWidth(width);
      setIsBelow1000px(width < 1001);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  console.log("windowWidth", windowWidth);

  const closeAllCollapses = () => {
    product.forEach((item) => {
      const collapseElement = document.getElementById(`flush-collapse${item.id}`);
      const buttonElement = document.querySelector(`[data-bs-target="#flush-collapse${item.id}"]`);
      if (collapseElement && buttonElement) {
        collapseElement.classList.remove("show");
        buttonElement.setAttribute("aria-expanded", "false");
      }
    });
  };

  const semiContainerStyle = {
    flex: 1,
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflowY: "auto",
    height: "calc(100vh - 70px)",
  };

  return (
    <div
      className="home_mainContainer position-relative"
      style={{ minHeight: "100vh", backgroundColor: "var(--bg-color)", display: "flex" }}
    >
      {isBelow1000px ? (
        <BackdropOffcanvas product={product} />
      ) : (
        <OffCanvas
          mainwidth={mainwidth}
          setMainWidth={setMainWidth}
          opaacity={opaacity}
          setOpacity={setOpacity}
          canvasWidth={canvasWidth}
          setCanvasWidth={setCanvasWidth}
          hide={hide}
          setHide={setHide}
          loading={loading}
          closeAllCollapses={closeAllCollapses}
        />
      )}

      <div
        className="main_content_wrapper d-flex flex-column transition-all"
        style={{
          flex: 1,
          width: isBelow1000px ? "100%" : `calc(100% - ${canvasWidth})`,
          marginLeft: isBelow1000px ? "0" : canvasWidth,
          transition: "margin-left 0.3s ease, width 0.3s ease",
          overflowX: 'hidden'
        }}
      >
        <Navbar
          setMainWidth={setMainWidth}
          mainwidth={mainwidth}
          setCanvasWidth={setCanvasWidth}
          setOpacity={setOpacity}
          setHide={setHide}
          closeAllCollapses={closeAllCollapses}
          isBelow1000px={isBelow1000px}
        />

        <div className="semi_container" style={semiContainerStyle}>
          <Routes>
            <Route path="home" element={<Dashboard />} />
            <Route
              path="functions"
              element={<ProtectedRoute element={<TabPanel />} permissionIds="functionalitiesID" />}
            />
            <Route
              path="Branchs"
              element={<ProtectedRoute element={<Branchs />} permissionIds="branchesID" />}
            />
            <Route
              path="Branchs/:id"
              element={<ProtectedRoute element={<BranchDetails />} permissionIds="showbranchesID" />}
            />
            <Route
              path="deps"
              element={<ProtectedRoute element={<Departments />} permissionIds="departmentsID" />}
            />
            <Route
              path="department/:id"
              element={<ProtectedRoute element={<DepartmentDetails />} permissionIds="showdepartmentsID" />}
            />
            <Route
              path="positions"
              element={<ProtectedRoute element={<JobPosition />} permissionIds="jobpositionsID" />}
            />
            <Route
              path="positions/:id"
              element={<ProtectedRoute element={<PositionDetails />} permissionIds="showjobpositionID" />}
            />
            <Route
              path="shifts"
              element={<ProtectedRoute element={<Shifts />} permissionIds="shiftsID" />}
            />
            <Route
              path="shift/:id"
              element={<ProtectedRoute element={<ShiftDetails />} permissionIds="showshiftsID" />}
            />
            <Route
              path="subshift/:id"
              element={<ProtectedRoute element={<Subshift />} permissionIds="showshiftsID" />}
            />
            <Route
              path="subshiftadd/:id"
              element={<ProtectedRoute element={<SubShiftAdd />} permissionIds="editshiftsID" />}
            />
            <Route
              path="Emp"
              element={<ProtectedRoute element={<Employee />} permissionIds="employeelistID" />}
            />
            <Route
              path="EmpDetails/:id"
              element={<ProtectedRoute element={<DetailsofEmp />} permissionIds="employeedetailsID" userIdParamKey="id" />}
            />
            <Route
              path="addEmp"
              element={<ProtectedRoute element={<AddEmployee />} permissionIds={["employeeaddID", "addemployeeID"]} />}
            />
            <Route
              path="editEmp/:emp_id"
              element={<ProtectedRoute element={<EditEmployee />} permissionIds="editemployeeID" />}
            />
            <Route
              path="salaryslip"
              element={<ProtectedRoute element={<SalarySlipList />} permissionIds="listemployeeID" />}
            />
            <Route
              path="processSalary"
              element={<ProtectedRoute element={<ProcessSalary />} permissionIds="listemployeeID" />}
            />
            <Route
              path="salaryslip/:emp_id"
              element={<ProtectedRoute element={<SalarySlip />} permissionIds="listsalaryslipID" userIdParamKey="emp_id" />}
            />
            <Route
              path="salaryslip/:emp_id/:id"
              element={<ProtectedRoute element={<SingleSalarySlip />} permissionIds="showsalaryslipID" userIdParamKey="emp_id" />}
            />
            <Route
              path="courses"
              element={<ProtectedRoute element={<CourseList />} permissionIds="coursesID" />}
            />
            <Route
              path="courses/:id"
              element={<ProtectedRoute element={<CourseDetails />} permissionIds="showcourseID" />}
            />
            <Route
              path="subcourses"
              element={<ProtectedRoute element={<Subjects />} permissionIds="subjectsID" />}
            />
            <Route
              path="subcourses/:id"
              element={<ProtectedRoute element={<SubjectDetails />} permissionIds="showsubjectID" />}
            />
            <Route
              path="todayLeaves"
              element={<ProtectedRoute element={<TodayLeaves />} permissionIds="todayleavesID" />}
            />
            <Route
              path="leaveDetails/:empId/:id"
              element={
                <ProtectedRoute
                  element={<LeaveDetail />}
                  permissionIds={[
                    "showtodayleavedetailsID",
                    "showpersonalleavesdetailsID",
                    "showleavereportdetailsID"
                  ]}
                  userIdParamKey="empId"
                />
              }
            />
            <Route
              path="leaveRequest"
              element={<ProtectedRoute element={<RequestView />} permissionIds="leaverequestsID" />}
            />
            <Route
              path="leaveReport"
              element={<ProtectedRoute element={<LeaveReport />} permissionIds="leavereportID" />}
            />
            <Route
              path="leaveReport/:id"
              element={<ProtectedRoute element={<SingleUserReport />} permissionIds="showleavereportID" userIdParamKey="id" />}
            />
            <Route
              path="leaveShow"
              element={<ProtectedRoute element={<LeaveShow />} permissionIds="companyleavesID" />}
            />
            <Route
              path="blncleaves"
              element={<ProtectedRoute element={<LeaveBalance />} permissionIds="balanceleavesID" />}
            />
            <Route
              path="userDetails"
              element={<ProtectedRoute element={<AddUser />} permissionIds="totalrolesID" />}
            />
            <Route
              path="roledetails/:id"
              element={<ProtectedRoute element={<RoleDetails />} permissionIds="totalrolesID" />}
            />
            <Route
              path="attendence"
              element={<ProtectedRoute element={<AllAttendence />} permissionIds="allattendanceID" />}
            />
            <Route
              path="dayList/:userId"
              element={<ProtectedRoute element={<SingleDayFullPunch />} permissionIds="attendancedetailsID" userIdParamKey="userId" />}
            />
            <Route
              path="attreport"
              element={<ProtectedRoute element={<Report />} permissionIds="employeeattendancereportID" />}
            />
            <Route
              path="regular"
              element={<ProtectedRoute element={<StdRegular />} permissionIds="attendanceregularizationID" />}
            />
            <Route
              path="punchreq"
              element={<ProtectedRoute element={<RequestList />} permissionIds="showallRegularizationrequestID" />}
            />
            <Route
              path="workinghours"
              element={<ProtectedRoute element={<WorkingHours />} permissionIds="workinghoursID" />}
            />
            <Route
              path="workinghours/:id"
              element={<ProtectedRoute element={<UserTime />} permissionIds="showindividualworkinghoursID" userIdParamKey="id" />}
            />
            <Route
              path="myattendence"
              element={<ProtectedRoute element={<MyAttendence />} permissionIds="myattendanceID" />}
            />
            <Route
              path="listing"
              element={<ProtectedRoute element={<Listing />} permissionIds="liststudentsID" />}
            />
            <Route
              path="stdaylist/:id"
              element={<ProtectedRoute element={<StudentDayPunch />} permissionIds="showstudentspunchID" />}
            />
            <Route
              path="student/:id"
              element={<ProtectedRoute element={<StudentDetails />} permissionIds="showstudentdetailsID" />}
            />
            <Route
              path="bill/:id"
              element={<ProtectedRoute element={<Download />} permissionIds="showfeerecieptID" />}
            />
            <Route
              path="addstd"
              element={<ProtectedRoute element={<AddStudent />} permissionIds="addstudentsID" />}
            />
            <Route
              path="editstd/:id"
              element={<ProtectedRoute element={<EditStudent />} permissionIds="editstudentsID" />}
            />
            <Route
              path="batches"
              element={<ProtectedRoute element={<Batches />} permissionIds="batchesID" />}
            />
            <Route
              path="batches/:id"
              element={<ProtectedRoute element={<BatchDetails />} permissionIds="showbatchesID" />}
            />
            <Route
              path="streport"
              element={<ProtectedRoute element={<StudentAttendanceReport />} permissionIds="studentattendancereportID" />}
            />
            <Route
              path="feereport"
              element={<ProtectedRoute element={<FeeReport />} permissionIds="feereportID" />}
            />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="selfLeave" element={<SelfLeaveTable />} />
            <Route path="leaveconvert" element={<LeaveConvert />} />
            <Route path="convertreq" element={<ConvertRequests />} />
            <Route path="earlyLate" element={<EarlyLate />} />
            <Route path="not-found" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/not-found" replace />} />

            <Route path="policy" element={<PolicyPage />} />
            <Route path="hierarchy" element={<OrganizationTree />} />
            <Route path="todayworkinghoures" element={<WorkingHouresReport />} />

          </Routes>
        </div>
      </div>
    </div>
  );
}